import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import navigateTo from '../app/navigateTo';

//Comps
import ModalContainer from '../modals/ModalContainer';
import FormSatIntegration from '../containers/account/components/FormSatIntegration';

// Redux
import store from '../app/store';
import { Provider } from 'react-redux';

// Icons
import SuccessIcon from '../img/icons/circles/success.png';
import WarningIcon from '../img/icons/circles/warning.png';
import DangerIcon from '../img/icons/circles/danger.png';
import SatIntegrationDownloads from '../containers/account/components/satIntegration/SatIntegrationDownloads';

export class BasicNotification extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string.isRequired
  };

  icons = {
    success: SuccessIcon,
    warning: WarningIcon,
    danger: DangerIcon
  };

  render() {
    const { color, title, message } = this.props;

    if (message === 'RFC no es válido') {
      const rcNotifications = document.querySelectorAll('.rc-notification');
      if (rcNotifications.length >= 2) {
        const rfcNotFound = rcNotifications[1];
        rfcNotFound.classList.add('rc-notification-onTopOf');
        setTimeout(() => {
          rfcNotFound.classList.remove('rc-notification-onTopOf');
        }, 5000);
      }
    }

    return (
      <div className={`notification notification--${color}`}>
        <img src={this.icons[color]} alt={`${color}_icon`} />
        <div>
          <h5 className="notification__title bold-text">{title}</h5>
          <p className="notification__message">{message}</p>
        </div>
      </div>
    );
  }
}

export class ImageNotification extends PureComponent {
  static propTypes = {
    img: PropTypes.string.isRequired,
    title: PropTypes.string,
    message: PropTypes.string.isRequired
  };

  render() {
    const { img, title, message } = this.props;

    return (
      <div className="notification notification--image">
        <div className="notification__image">
          <img src={img} alt="" />
        </div>
        <h5 className="notification__title bold-text">{title}</h5>
        <p className="notification__message">{message}</p>
      </div>
    );
  }
}

export class FullWideNotification extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    message: PropTypes.string.isRequired
  };

  render() {
    const { color, message } = this.props;

    return (
      <div className={`notification notification--full-wide notification--${color}`}>
        <p className="notification__message">{message}</p>
      </div>
    );
  }
}

export class TopbarNotification extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    message: PropTypes.string.isRequired,
    messageTitle: PropTypes.string,
    icon: PropTypes.object,
    action: PropTypes.string,
    actionFunction: PropTypes.func
  };

  constructor() {
    super();
    this.state = {
      close: false,
      showSatModalFromAlert: false,
      toSubscription: false
    };
  } //END constructor

  /**
   * Maneja la acción a realizar dependiendo del texto de cta
   * @param {string}      action Call to action copy
   * @returns {function}         Si el cta es redireccionamiento regresa función para cambiar ruta
   */
  sendAndClose = action => {
    const { actionFunction } = this.props;

    if (action === 'Reenviar correo') {
      actionFunction();
    } else if (action === 'Más información') {
      this.setState({ showSatModalFromAlert: true });
      actionFunction();
    } else if (action === 'Mejora tu plan') {
      return navigateTo({ to: '/app/subscription' });
    } else if (action === 'Ver integraciones') {
      return navigateTo({ to: '/account/integrations' });
    }

    const notification = document.querySelectorAll('.alert-notification');
    if (notification.length === 1) {
      notification[0].remove();
    } else if (action === 'Más información') {
      notification[1].remove();
    } else if (action === 'Reenviar correo') {
      notification[0].remove();
    }
  }; //END sendAndClose

  render() {
    const { color, message, messageTitle, icon, action } = this.props;
    const { close, showSatModalFromAlert } = this.state;

    return (
      <React.Fragment>
        <Provider store={store}>
          <ModalContainer
            color="basic"
            title="Importar desde SAT"
            identifierClass="integration__from-instructions"
            hooks={{ onClose: () => this.setState({ showSatModalFromAlert: false }) }}
            header
            visible={showSatModalFromAlert ? true : false}
            helpCenterlink="https://help.porcobrar.com/es/articles/3658601-como-integro-por-cobrar-con-el-sat"
          >
            <SatIntegrationDownloads />
          </ModalContainer>
        </Provider>
        <div
          className={`notification notification--full-wide notification--${color} ${close ? 'hide-notification' : ''}`}
          style={{ background: color === 'warning' ? '#F3A72E' : '#E9494E', border: 'none' }}
        >
          <div className="alert-notification-wrapper">
            <div className="icon-container" style={{ background: color === 'warning' ? '#ED9810' : '#DD4348' }}>
              {icon}
            </div>
            <p className="notification__message">
              <span>{messageTitle}</span> {message}
            </p>
          </div>
          <div className="notification-action-wrapper">
            <button onClick={() => this.sendAndClose(action)}>{action}</button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Notification.js